export function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
  }
}
export function useloginInfoset(response: any) {
  localStorage.setItem("accessToken", response.accessToken);
  localStorage.setItem("refreshToken", response.refreshToken);
  localStorage.setItem("firstName", response.firstName);
  localStorage.setItem("lastName", response.lastName);
  localStorage.setItem("roleName", response.roleName);
  document.cookie = `roleName=${response.roleName}; path=/`;
  document.cookie = `token=${response.accessToken}; path=/`;
}
export function preventSpace(event: any) {
  if (event.key === " ") {
    event.preventDefault();
  }
}
export function throttle(func: any, wait: any) {
  let timeout;
  let throttled = false;

  return function executedFunction(...args: any) {
    if (!throttled) {
      throttled = true;
      func(...args);

      timeout = setTimeout(() => {
        throttled = false;
      }, wait);
    }
  };
}
export const allowOnlyNumbers = (e: any) => {
  if (e.keyCode === 8) {
    return;
  }
  // Replace any non-numeric character with an empty string
  if (!/^\d+$/.test(e.key)) {
    e.preventDefault();
  }
};
export function validateTwoDigitNumber(e: any, maxDigit: number) {
  const input = e.target.value;
  // Convert input to a number

  let number = parseInt(input, 10);

  // Check if the input is a valid number
  if (isNaN(number)) {
    console.error("Invalid input: not a number.");
    return null;
  }

  // Restrict number to be within the range of 0 to 99
  if (number < 0) {
    number = 0;
  } else if (number > maxDigit) {
    number = maxDigit;
  }

  // Format the number to ensure it has exactly two digits
  let formattedNumber = number.toString().padStart(2, "0");

  return formattedNumber;
}
export const allowMaximumMonths = (e: any) => {
  allowOnlyNumbers(e);
  const input = e.target.value;
  let month = parseInt(input, 10);

  // Check if the input is a valid number
  if (isNaN(month)) {
    console.error("Invalid input: not a number.");
    return null;
  }

  // Restrict month to be within the range of 1 to 12
  if (month < 0) {
    month = 0;
  } else if (month >= 12) {
    month = 11;
  }

  // Format the month to ensure it has exactly two digits
  let formattedMonth = month.toString().padStart(2, "0");

  return formattedMonth;
};
export const doNotAllowSpecial = (e: any) => {
  if (e.keyCode === 8) {
    return; // Allow backspace
  }

  // Prevent input if key pressed is not a number
  // Prevent default action for non-numeric characters
  if (!/^[0-9a-zA-Z]+$/.test(e.key)) {
    e.preventDefault();
  }
};
export const logoutUser = () => {
  // Perform logout actions (e.g., clear token, redirect to login page)
  localStorage.clear();
  deleteAllCookies();

  // Redirect to login page or show a logout message
  if (!window.location.pathname.includes("auth")) {
    window.location.href = "/login";
  }
};

// Function to validate IFSC code
export function validateIFSC(ifsc: any) {
  var ifscPattern = /^[A-Za-z]{4}\d{7}$/; // Example pattern: ABCD1234567

  return ifscPattern.test(ifsc);
}
export function validateBankAccountNumber(bankNumber: any) {
  var ifscPattern = /^\d{12}$/; // Example pattern: ABCD1234567

  return ifscPattern.test(bankNumber);
}

// export Function to validate Aadhaar number
export function validateAadhaar(aadhaar: any) {
  var aadhaarPattern = /^\d{12}$/; // 12 digit number

  return aadhaarPattern.test(aadhaar);
}

// export Function to validate PAN card number
export function validatePAN(pan: any) {
  var panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/; // Example pattern: ABCDE1234F

  return panPattern.test(pan);
}

export const getWeekDayForCurrentYear = (date: any) => {
  const birthDate = new Date(date);
  const currentYear = new Date().getFullYear();
  const currentDate = new Date(
    currentYear,
    birthDate.getMonth(),
    birthDate.getDate()
  );

  const weekday = currentDate.toLocaleDateString("en-GB", {
    weekday: "short",
  });

  return weekday;
};
// export Function to validate PF number
export function validatePF(pf: any) {
  var pfPattern = /^\d{7,}$/; // Minimum 7 digits

  return pfPattern.test(pf);
}
export function convertUTCDateToLocalDate(date: Date) {
  var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return newDate.toISOString();
}
export const dateToMonth = (date: string) => {
  return new Date(date).toLocaleDateString("en-GB", {
    month: "short",
  });
};
export function formatDate(dateString: Date | string) {
  //common function to format date in format like "Sat 4 May, 2024"
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const date = new Date(dateString);
  const day = days[date.getDay()];
  const month = months[date.getMonth()];
  const dayOfMonth = date.getDate();
  const year = date.getFullYear();

  return `${day} ${dayOfMonth} ${month}, ${year}`;
}
export const formattedDate = (date: Date) => {
  if (!date) return "N/A";

  return date?.toLocaleDateString("en-US", {
    month: "2-digit", // Numeric representation of the month (01-12)
    day: "2-digit", // Numeric representation of the day (01-31)
    year: "numeric", // Full numeric representation of the year (e.g., 2024)
  });
};
export const formattedDateDMY = (date: Date) => {
  return date.toLocaleDateString("en-US", {
    day: "2-digit", // Numeric representation of the day (01-31)
    month: "2-digit", // Numeric representation of the month (01-12)
    year: "numeric", // Full numeric representation of the year (e.g., 2024)
  });
};

export const formattedDateYMD = (date: Date) => {
  if (!date) return "N/A";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
};

export const getTodayDateUTC = (date: Date) => {
  return new Date(
    new Date(date).getTime() - new Date(date).getTimezoneOffset() * +60000
  )?.toISOString();
};
// const renderFilePreview = (file: File, size?: any) => {
//   if (!file) return null;

//   if (file.type.startsWith("image/")) {
//     // Render image preview
//     return (
//       <img
//         src={URL.createObjectURL(file)}
//         alt="File preview"
//         height={size ? size : 300}
//         width={size ? size : 300}
//       />
//     );
//   } else {
//     // Render file name
//     return <p>{file.name}</p>;
//   }
// };
export function trimHTMLText(htmlString: any, maxLength: number) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const textContent = doc.body.textContent || "";

  if (textContent.length > maxLength) {
    const trimmedText = textContent.substring(0, maxLength) + "...";
    doc.body.textContent = trimmedText;
  }

  return doc.body.innerHTML;
}

export function getCorrectDate(dateString: string | null) {
  if (!dateString) {
    return null;
  }

  const date = formatDate(dateString);

  return date;
}

export const formatDataforCustomer = (data: any) => {
  function createData(id: any, label: string, value: string | number): any {
    return { id, label, value };
  }

  return data?.map((item: any, i: number) =>
    createData(
      item?.customerId || item?.customerID,
      item?.customerName,
      item?.customerId || item?.customerID
    )
  );
};
export const formatDataforUser = (data: any) => {
  function createData(id: any, label: string, value: string | number): any {
    return { id, label, value };
  }

  return data?.map((item: any, i: number) =>
    createData(
      item?.employeeID,
      item?.fullName,
      item?.employeeID?.toLowerCase()
    )
  );
};

export const formatDateToGlobal = (date: Date) => {
  return date instanceof Date
    ? date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : ""
}
